export default __webpack_public_path__ + "static/media/httpswww.youtube.comwatchv=V8m9AMxMG6g&ab_channel=Juztify.3976b45e.jpg";